import HeaderBlack from "./components/header-black";
import PageTitle from "./components/page-title";
import {ActionButton} from "./components/action-button";
import GetInTouchInput from "./components/form_input";
import {useEffect, useState} from "react";
import './analytics.css'

export default function Analytics() {
    const [hideIps, setHideIps] = useState('');
    const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
    const [day, setDay] = useState('');
    const [visits, setVisits] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState('');

    useEffect(() => {
        if (visits.length > 0 && visits.some(v => !v.Location)) {
            getLocations();
       }
    }, [visits,]);

    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    };


    const getLocations = async () => {
        setLoading('Loading locations...');
        console.log('Getting locations for visits, ' + visits.length);
        const updatedVisits = [...visits];

        for (let v of updatedVisits) {
            console.log(Date.now().toString());
            if (v.Location) {
                continue;
            }

            try {
                const response = await fetch(`https://ip-geo-location.p.rapidapi.com/ip/${v["From"]}?format=json&language=en`, {
                    method: 'GET',
                    headers: {
                        "X-RapidAPI-Key": "b14e5c2979msh863c9b4e1eed8eap141f6ajsn8625d31cc8be",
                        "X-RapidAPI-Host": "ip-geo-location.p.rapidapi.com"
                    },
                });
                const responseData = await response.json();
                console.log('Got location response for ip ' + v["From"], responseData);
                v['Location'] = responseData.city?.name || responseData.area?.name || 'Unknown';
            } catch (error) {
                v['Location'] = 'Unknown';
            }

            // setVisits([...updatedVisits]);

            await sleep(1000);
        }

        setVisits([...updatedVisits]);
        setLoading('');
    };

    const getToday = () => {
        fetch('https://wxptzs7h54.execute-api.eu-central-1.amazonaws.com/prod/today', {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => response.json().then((responseData) => {
            setVisits(responseData);
            setDay(new Date().getDay().toString().padStart(2, '0'));
            setDate(new Date().toISOString().slice(0, 10))
        }), (error) => {
            setError('Error: ' + error.toString());
        });
    }

    const getDate = () => {
        const searchParams = new URLSearchParams()
        searchParams.append('date', date);

        fetch(`https://wxptzs7h54.execute-api.eu-central-1.amazonaws.com/prod/date?${searchParams.toString()}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => response.json().then((responseData) => {
            setVisits(responseData);
            setDay(new Date().getDay().toString().padStart(2, '0'));
        }), (error) => {
            setError('Error: ' + error.toString());
        });
    }

    return (
        <div>
            <HeaderBlack />

            <PageTitle title={'Analytics'}
                       subtitle={'Hai sa vedem cine a intrat pe site-ul nostru'}
                       className="black-background white-color-txt" />
            <div id="analytics-form" className='page-padding mt-3'>
                <div className='git-row'>
                    <GetInTouchInput label="Ip to hide" value={hideIps} onChange={e => setHideIps(e.target.value)} />
                </div>

                <div className='grey-color-text'>Lista de IP-uri separate cu ','</div>

                <div className='git-row mt-2'>
                    <GetInTouchInput label="Date" value={date} onChange={e => setDate(e.target.value)} />
                </div>

                <div className='git-row mt-2'>
                    <GetInTouchInput label="Day" value={day} onChange={e => setDay(e.target.value)} />
                </div>

                <div className='git-row'>
                    <ActionButton className='primary-color white-color-txt light-button-hover align-self-end mt-4' onClick={() => getDate()} text={!loading ? "Get date": "Wait"} />

                    <ActionButton className='primary-color white-color-txt light-button-hover align-self-end mt-4' onClick={() => getToday()} text={!loading ? "Get today": "Wait"} />
                </div>
            </div>

            <div className='page-padding mt-2'>{!!loading ? loading : "Ready"}</div>

            <div className='visits-rows page-padding mt-2'>
                <div>
                    <div className='t5'>Name</div>
                    {
                        visits.map( (visit, index) => <div key={index} className='b1'>
                            <div className='ip'>{visit['Name']}</div>
                        </div>)
                    }
                </div>

                <div>
                    <div className='t5'>Date</div>
                    {
                        visits.map( (visit, index) => <div key={index} className='b1'>
                            <div className='ip'>{visit['RequestTime'].slice(0, 16)}</div>
                        </div>)
                    }
                </div>

                <div>
                    <div className='t5'>IP</div>
                    {
                        visits.map( (visit, index) => <div key={index} className='b1'>
                            <div className='ip'>{visit['From']}</div>
                        </div>)
                    }
                </div>

                <div>
                    <div className='t5'>City</div>
                    {
                        visits.map( (visit, index) => <div className='b1'>
                            <div key={index} className='ip'>{visit['Location']}</div>
                        </div>)
                    }
                </div>

                <div>
                    <div className='t5'>Type</div>
                    {
                        visits.map( (visit, index) => <div className='b1'>
                            <div key={index} className='ip'>{visit['Type']}</div>
                        </div>)
                    }
                </div>
            </div>

            { error && <div className='error-text page-padding mt-4'>{error}</div> }

            <div className='space-100' />

        </div>
    );
}